/*
 * This domain is being used when...
 * ..creating a build for TDEV
 * ..working on localhost
 *
 * Change this domain to 'siptrunk.nfon.com' to use the PROD environment on localhost
 */
export const UCAPI_TDEV_DOMAIN: string = "siptrunk-test.nfon.com";
/*
 * This domain is being used when creating a build for the PROD environment
 */
export const UCAPI_PROD_DOMAIN: string = window.location.host;

/**
 * Sign of type server deployment
 * "id-test." - tdev server
 * "id-preview." - preview server
 * "localhost" - run localy
 */
export const TYPE_SERVER_SUBDOMAIN: string[] = ["sso-test", "sso", "localhost"];
